<template>
  <div class="content-text-with-image-skeleton">
    <div class="content-text-with-image-skeleton__content">
      <div>
        <SHeadingSkeleton size="2" width="240px" />
        <STextSkeleton :lines="6" />
      </div>
      <div>
        <SHeadingSkeleton size="3" width="240px" />
        <STextSkeleton :lines="3" />
      </div>
    </div>
    <div class="content-text-with-image-skeleton__image">
      <PSkeleton height="100%" />
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  PSkeleton,
  SHeadingSkeleton,
  STextSkeleton,
} from "@solvari/components";
</script>

<style lang="postcss">
.content-text-with-image-skeleton {
  @apply flex flex-col gap-8;

  @screen 700 {
    @apply flex-row gap-12;
  }

  &__content {
    @apply flex flex-1 flex-col gap-8;
  }

  &__image {
    @apply aspect-square w-full rounded-xl;

    @screen 700 {
      @apply w-52 shrink-0;
    }

    @screen 900 {
      @apply w-64;
    }

    @screen 1000 {
      @apply w-72;
    }

    @screen 1100 {
      @apply w-80;
    }

    @screen 1200 {
      @apply w-96;
    }
  }
}
</style>
